<template>
	<div class="evento">
		<div class="evento-header">
			<div class="evento-header-background" :class="fondoTipoBlurred ? 'blurry' : ''" :style="'background-image: url(' + evento.Evento.EventoFotoPortada + ');'" v-if="!isCargandoEvento"></div>
			<div class="container">
				<div class="evento-header-content-left" v-if="!isCargandoEvento">
					<div class="breadcrumb">
						<router-link :to="{ name: 'home' }" class="breadcrumb-item">Inicio</router-link>
						<div class="breadcrumb-item">&#8594;</div>
						<router-link :to="{ name: 'eventos' }" class="breadcrumb-item">Eventos</router-link>
						<div class="breadcrumb-item">&#8594;</div>
						<div class="breadcrumb-item">{{ evento.Categorias.EventoCategoriaNombre }}</div>
						<div class="breadcrumb-item" v-if="evento.Categorias.EventoSubcategoriaNombre">&#8594;</div>
						<div class="breadcrumb-item" v-if="evento.Categorias.EventoSubcategoriaNombre">{{ evento.EventoSubcategoriaNombre }}</div>
					</div>
					<h1>{{ evento.Evento.EventoNombre }}</h1>
					<button @click.prevent="$refs['sectores'].scrollIntoView({ behavior: 'smooth' })">
						Comprar entradas
					</button>
					<div class="divider"></div>
					<div class="evento-header-footer">
						<div class="evento-involucrados">
							<div class="involucrado" v-if="Number(evento.Involucrados.OrganizadorId) > 0 && Number(evento.Involucrados.InstitucionLocalId) <= 0 && Number(evento.Involucrados.InstitucionVisitanteId) <= 0" :data-tooltip="evento.Involucrados.OrganizadorNombre" :style="{ 'background-color': '#' + evento.Involucrados.OrganizadorBackgroundColor}">
								<img :src="evento.Involucrados.OrganizadorLogo" :alt="evento.Involucrados.OrganizadorNombre">
							</div>
							<div class="involucrado" v-if="Number(evento.Involucrados.InstitucionLocalId) > 0" :data-tooltip="evento.Involucrados.InstitucionLocalNombre" :style="{ 'background-color': '#' + evento.Involucrados.InstitucionLocalBackgroundColor}">
								<img :src="evento.Involucrados.InstitucionLocalEscudo" :alt="evento.Involucrados.InstitucionLocalNombre">
							</div>
							<div class="involucrado" v-if="Number(evento.Involucrados.InstitucionVisitanteId) > 0" :data-tooltip="evento.Involucrados.InstitucionVisitanteNombre" :style="{ 'background-color': '#' + evento.Involucrados.InstitucionVisitanteBackgroundColor}">
								<img :src="evento.Involucrados.InstitucionVisitanteEscudo" :alt="evento.Involucrados.InstitucionVisitanteNombre">
							</div>
						</div>
						<div class="evento-competencia" v-if="Number(evento.Competencia.CompetenciaId) > 0">
							<div class="evento-competencia-logo">
								<img :src="evento.Competencia.CompetenciaImagen" :alt="evento.Competencia.CompetenciaNombre">
							</div>
							<div class="evento-competencia-main">
								<span class="evento-competencia-nombre">{{ evento.Competencia.CompetenciaNombre }}</span>
								<span class="evento-competencia-instancia" v-if="Number(evento.Competencia.CompetenciaInstanciaId) > 0">{{ evento.Competencia.CompetenciaInstanciaNombre }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="evento-header-content-left skeleton" v-else>
					<SkeletonEventoHeaderLeft />
				</div>
				<div class="evento-header-content-right skeleton" v-if="isCargandoEvento">
					<SkeletonEventoHeaderRight />
				</div>
				<div class="evento-header-content-right" v-else-if="fondoTipoBlurred">
					<div class="flyer">
						<vue-picture-swipe id="flyer"
							:items="evento.Evento.EventoFlyerCol"
							:options="{ shareEl: false, modal: true }"
							@open="flyerOpened()"
							@close="flyerClosed()"
						></vue-picture-swipe>
						<div class="ver-flyer" @click.prevent="triggerFlyerClick()">Ver flyer</div>
					</div>
				</div>
			</div>
		</div>
		<div class="evento-main">
			<clip-loader class="evento-loader" :loading="isCargandoEvento" :color="'var(--color-primary)'" :size="'52px'"></clip-loader>
			<div :class="evento.Escenario.EventoRepresentacionGrafica ? 'container' : 'container'" v-if="!isCargandoEvento">
				<div class="evento-main-content">
					<div class="evento-main-content-top">
						<div class="evento-main-content-top-card">
							<div class="evento-fecha">
								<div class="evento-fecha-left">
									<span class="fecha-dia-escrito">{{ evento.Fecha.EventoFechaDiaEscrito }}</span>
									<span class="fecha-dia">{{ evento.Fecha.EventoFechaDia }}</span>
									<span class="fecha-mes">{{ evento.Fecha.EventoFechaMes }}</span>
								</div>
								<div class="evento-fecha-divider"></div>
								<div class="evento-fecha-right">
									<span class="fecha-hora">{{ evento.Fecha.EventoFechaHora }}</span>
								</div>
							</div>
						</div>
						<div class="evento-main-content-top-card">
							<div class="evento-organizador">
								<div class="evento-organizador-left">
									<span class="label">Organiza</span>
									<span class="organizador-nombre">{{ evento.Involucrados.OrganizadorNombre }}</span>
								</div>
								<div class="evento-organizador-right" v-if="evento.Involucrados.OrganizadorLogo">
									<div class="organizador-logo">
										<img :src="evento.Involucrados.OrganizadorLogo" :alt="evento.Involucrados.OrganizadorNombre" />
									</div>
								</div>
							</div>
						</div>
						<div class="evento-main-content-top-card">
							<div class="evento-escenario">
								<div class="evento-escenario-left">
									<span class="label">Lugar</span>
									<span class="escenario-nombre">{{ evento.Escenario.EscenarioNombre }}</span>
								</div>
								<div class="evento-escenario-right" v-if="evento.Escenario.EscenarioMapaURL">
									<a :href="evento.Escenario.EscenarioMapaURL" target="_blank">
										<i class="bx bx-link-external"></i>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="venue-map" v-if="evento.Escenario.EventoRepresentacionGrafica && evento.Escenario.EscenarioSVG" v-html="evento.Escenario.EscenarioSVG" @click.prevent="seleccionarSectorFromMap" :class="[sectorActivo ? 'esc-sec-elegido' : '']"></div>
					<span class="descripcion-title" ref="sectores" v-if="isAlertaTransaccionConfirmed">Elegí tu acceso</span>
					<div class="sectores" v-if="isAlertaTransaccionConfirmed">
						<div class="sector-wrapper" v-for="sector in sectores" :key="sector.SectorCod" :id="'SEC-' + sector.SectorCod">
							<div class="sector"
								:class="
									  sector.Segmentos.length <= 0 ? 'no-configurado'
									: sector.EventoSectorAgotado && sectorActivo ? 'agotado deselected'
									: sector.EventoSectorAgotado ? 'agotado'
									: sectorActivo === sector.SectorCod ? 'active'
									: sectorActivo ? 'deselected'
									: ''
								"
								@click.prevent="seleccionarSector(sector.SectorCod, false)"
							>
								<div class="sector-left">
									<span class="tribuna-nombre" v-if="sector.SectorDescripcion.trim().toUpperCase() !== sector.TribunaNombre.trim().toUpperCase()">{{ sector.TribunaNombre }}</span>
									<span class="sector-nombre">{{ sector.SectorDescripcion }}</span>
									<span class="sector-descripcion" v-if="sector.EventoSectorInfo">{{ sector.EventoSectorInfo }}</span>
								</div>
								<div class="sector-right" v-if="sector.Segmentos.length > 0 && evento.Evento.EventoSegmentoElegible">
									<div class="segmento-cantidad" v-if="sectorActivo === sector.SectorCod && sector.Segmentos.length === 1 && !sector.EventoSectorAgotado">
										<div class="segmento-cantidad-less" @click.stop="segmentoQtyLess(sector.SectorCod, sector.Segmentos[0].SegmentoId)">
											<i class="bx bx-minus"></i>
										</div>
										<div class="segmento-cantidad-qty">
											{{ sector.Segmentos[0].SegmentoCantidad }}
										</div>
										<div class="segmento-cantidad-more" @click.stop="segmentoQtyMore(sector.SectorCod, sector.Segmentos[0].SegmentoId)">
											<i class="bx bx-plus"></i>
										</div>
									</div>
									<!-- <span class="sector-desde" v-if="sectorActivo !== sector.SectorCod && !sector.EventoSectorAgotado">Desde {{ sectoresInfo.MonedaSimbolo }}{{ sector.SectorPrecioDesde }}</span> -->
									<div class="sector-desde" v-if="sectorActivo !== sector.SectorCod && !sector.EventoSectorAgotado && sector.Segmentos.length > 1">Desde {{ sectoresInfo.MonedaSimbolo }}{{ sector.SectorPrecioDesde }}</div>
									<div class="sector-precio" v-if="sector.Segmentos.length === 1">{{ sectoresInfo.MonedaSimbolo }}{{ sector.Segmentos[0].ListaMontoInt }}</div>
									<span class="sector-agotado" v-if="sector.EventoSectorAgotado">Agotado</span>
								</div>
								<div class="sector-right" v-if="sector.Segmentos.length > 0 && !evento.Evento.EventoSegmentoElegible">
									<div class="sector-cantidad" v-if="!sector.EventoSectorAgotado && sectorActivo === sector.SectorCod">
										<div class="sector-cantidad-less" @click.stop="sectorQtyLess(sector.SectorCod)">
											<i class="bx bx-minus"></i>
										</div>
										<div class="sector-cantidad-qty">
											{{ sector.SectorCantidad }}
										</div>
										<div class="sector-cantidad-more" @click.stop="sectorQtyMore(sector.SectorCod)">
											<i class="bx bx-plus"></i>
										</div>
									</div>
									<div class="sector-desde" v-if="sectorActivo !== sector.SectorCod && !sector.EventoSectorAgotado && sector.Segmentos.length > 1">Desde {{ sectoresInfo.MonedaSimbolo }}{{ sector.SectorPrecioDesde }}</div>
									<div class="sector-precio" v-if="sector.Segmentos.length === 1">{{ sectoresInfo.MonedaSimbolo }}{{ sector.Segmentos[0].ListaMontoInt }}</div>
									<span class="sector-agotado" v-if="sector.EventoSectorAgotado">Agotado</span>
								</div>
								<div class="no-configurado-aviso" v-if="sector.Segmentos.length <= 0">
									<i class='bx bxs-lock-alt'></i>
									<span>No disponible aún</span>
								</div>
							</div>
							<div class="segmentos" v-show="sectorActivo === sector.SectorCod" v-if="sector.Segmentos.length > 1">
								<div class="segmento" v-for="segmento in sector.Segmentos" :key="segmento.SegmentoId">
									<div class="segmento-left">
										<span class="segmento-nombre">{{ segmento.SegmentoNombre }}</span>
										<span class="segmento-descripcion" v-if="segmento.EventoSegmentoInfo">{{ segmento.EventoSegmentoInfo }}</span>
									</div>
									<div class="segmento-right">
										<div class="segmento-cantidad" v-if="evento.Evento.EventoSegmentoElegible">
											<div class="segmento-cantidad-less" @click.stop="segmentoQtyLess(sector.SectorCod, segmento.SegmentoId)">
												<i class="bx bx-minus"></i>
											</div>
											<div class="segmento-cantidad-qty">
												{{ segmento.SegmentoCantidad }}
											</div>
											<div class="segmento-cantidad-more" @click.stop="segmentoQtyMore(sector.SectorCod, segmento.SegmentoId)">
												<i class="bx bx-plus"></i>
											</div>
										</div>
										<span class="segmento-precio">{{ sectoresInfo.MonedaSimbolo }}{{ segmento.ListaMontoInt }}</span>
									</div>
								</div>
							</div>
							<span class="error-checkout" v-if="sectorActivo === sector.SectorCod && errorCheckout">
								{{ errorCheckout }}
							</span>
							<button v-if="sectorActivo === sector.SectorCod" @click.prevent="goToCheckout()" :disabled="isLoadingCheckout">
								Comprar
							</button>
						</div>
					</div>
					<span class="descripcion-title">Información del evento</span>
					<p v-html="evento.Evento.EventoDescripcion"></p>
				</div>
				<aside>
					<div class="evento-caracteristicas">
						<div class="caracteristica">
							<i class="bx bx-qr"></i>
							<div class="caracteristica-right">
								<span class="caracteristica-title">Ticket digital</span>
								<span class="caracteristica-subtitle"
									>Accede al evento con tu código QR</span
								>
							</div>
						</div>
						<div class="caracteristica">
							<i class="bx bx-credit-card"></i>
							<div class="caracteristica-right">
								<span class="caracteristica-title">Pago seguro</span>
								<span class="caracteristica-subtitle"
									>Paga seguro a través de MercadoPago</span
								>
							</div>
						</div>
						<div class="caracteristica">
							<i class="bx bx-shield-x"></i>
							<div class="caracteristica-right">
								<span class="caracteristica-title">Devoluciones</span>
								<span class="caracteristica-subtitle"
									>Una vez emitido el ticket, no se realizan cancelaciones ni
									devoluciones</span
								>
							</div>
						</div>
					</div>
					<div class="map-wrapper" v-show="isShowMap">
						<div id="map"></div>
					</div>
					<div class="map-wrapper-show" v-show="!isShowMap && evento && evento.Escenario.EscenarioGeo">
						<span class="show-map" @click.prevent="showMap()"><i class='bx bx-map-alt'></i>Mostrar ubicación</span>
					</div>
				</aside>
			</div>
		</div>
		<modal name="transaccion-en-curso" class="transaccion-en-curso" transition="scale" mode="in-out" :clickToClose="false">
			<div class="alerta">
				<i class='bx bxs-info-circle'></i>
			</div>
			<div class="transaccion-en-curso-content">
				<div class="transaccion-en-curso-main" v-if="trnEnCurso">
					<span class="atencion">Ya tienes una compra en curso</span>
					<div class="transaccion-anterior">
						<div class="transaccion-anterior-foto">
							<img :src="trnEnCurso.EventoFotoPrincipal" :alt="trnEnCurso.TransaccionEventoSectorDescripcion">
						</div>
						<div class="transaccion-anterior-main">
							<div class="transaccion-anterior-left">
								<span class="transaccion-anterior-sector">{{ trnEnCurso.TransaccionEventoSectorDescripcion }}</span>
								<span class="transaccion-anterior-sector-info">{{ trnEnCurso.TransaccionEventoSectorInfo }}</span>
							</div>
							<div class="transaccion-anterior-right">
								<span class="transaccion-anterior-cantidad">x{{ trnEnCurso.TransaccionCantidad }}</span>
							</div>
						</div>
					</div>
					<button @click.prevent="retomarCompra()">Retomar esta compra</button>
				</div>
				<div class="buttons">
					<button class="no-quedarme" @click="esconderTransaccionEnCurso()">Realizar una nueva compra</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios';
	import mapboxgl from "mapbox-gl";
	import { mapState, mapActions } from "vuex";
	import SkeletonEventoHeaderLeft from '../components/skeletons/SkeletonEventoHeaderLeft.vue';
	import SkeletonEventoHeaderRight from '../components/skeletons/SkeletonEventoHeaderRight.vue';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data() {
			return {
				// Evento
				eventoId: Number(this.$route.params.eventId),
				eventoSlug: this.$route.params.eventSlug,
				isCargandoEvento: true,
				evento: {},

				// Mapa
				mapboxAccessToken: process.env.VUE_APP_MAPBOX_TOKEN,
				isShowMap: false,

				// Transaccion
				isLoadingCheckout: false,
				transaccionId: null,

				// Promotor
				EventoPromotorEmail: '',

				// Asientos
				ticketsUbicaciones: [],

				sectoresInfo: {
					MonedaId: null,
					MonedaSimbolo: null
				},
				sectorActivo: null,
				sectores: [],
				errorCheckout: null,

				isAlertaTransaccionConfirmed: false,
				trnEnCurso: null,
				
				// Seo
				seo: {
					eventoNombre: 'Be There',
					eventoFoto: 'https://lineuptickets.com/images/lineup-og.jpg',
					eventoDescripcion: ''
				}
			};
		},
		computed: {
			sectorActivoObj() {
				if (!this.sectorActivo) {
					return null;
				} else {
					return this.sectores.filter((s) => {
						return s.SectorCod === this.sectorActivo;
					});
				}
			},
			fondoTipoBlurred(){
				if(this.evento.Evento.EventoFlyer){
					return true
				} else {
					return false
				}
			},

			...mapState("AuthModule", ["loggedIn", "user"])
		},
		components: {
			ClipLoader,
			SkeletonEventoHeaderLeft,
			SkeletonEventoHeaderRight
		},
		metaInfo() {
			const eventoTitle = 'Entradas para ' + this.seo.eventoNombre
			const eventoNombre = this.seo.eventoNombre + ' | LineUp Tickets'
			const eventoFoto = this.seo.eventoFoto
			const eventoURL = this.$route.query.page
			const eventoDescripcion = this.seo.eventoDescripcion + ' | LineUp Tickets'

			return {
				title: eventoTitle,
				titleTemplate: '%s 🎟 LineUp Tickets',
				meta: [
					{ property: 'og:title', content: eventoNombre, vmid: 'og:title' },
					{ property: 'og:description', content: eventoDescripcion, vmid: 'og:description' },
					{ property: 'og:url', content: eventoURL, vmid: 'og:url' },
					{ property: 'og:image', content: eventoFoto, vmid: 'og:image' },
					{ property: 'og:image:alt', content: eventoNombre, vmid: 'og:image:alt' },
					{ name: 'twitter:title', content: eventoNombre, vmid: 'twitter:title' },
					{ name: 'twitter:description', content: eventoDescripcion, vmid: 'twitter:description' },
					{ name: 'twitter:image', content: eventoFoto, vmid: 'twitter:image' },
					{ name: 'twitter:image:alt', content: eventoNombre, vmid: 'twitter:image:alt' },
				]
			}
		},
		async mounted() {
			this.$store.dispatch('cargando', true);

			// this.$store.dispatch('limpiarCheckout');
			this.$store.dispatch('limpiarTransaccionData')

			if(this.loggedIn){
				await this.transaccionEnCurso();
			} else {
				this.isAlertaTransaccionConfirmed = true
			}

			await this.getEvento();
			await this.getEventoSectores();

			if(this.$route.params.promotorCodigo){
				if(this.evento.Evento.EventoAdmitePromotores === true){
					await this.validarPromotorCodigo();
				} else {
					this.$router.push({ name: 'evento', params: { eventSlug: this.eventoSlug, eventId: this.eventoId } });
				}
			}

			this.$store.dispatch('cargando', false);
		},
		methods: {
			...mapActions('AuthModule', ['logout']),

			async getEvento(){
				try {
					let response = await axios.post('/WSEvento',
						{
							EventoId: this.eventoId,
							EventoSlug: this.eventoSlug
						}
					);

					if(response.data.ErrorCod === 0){
						let flyerWidth = 0;
						let flyerHeight = 0;

						const getMeta = (url) =>
							new Promise((resolve, reject) => {
								const img = new Image();
								img.onload = () => resolve(img);
								img.onerror = (err) => reject(err);
								img.src = url;
							});

						this.evento = response.data.SDTEvento
						this.seo.eventoNombre = response.data.SDTEvento.Evento.EventoNombre.trim()
						this.seo.eventoDescripcion = response.data.SDTEvento.Evento.EventoDescripcion.trim()
						this.seo.eventoFoto = response.data.SDTEvento.Evento.EventoFotoPrincipal.trim()

						if(this.evento.Escenario.EventoRepresentacionGrafica && this.evento.Escenario.EscenarioSVG){
							this.deseleccionarSector();
						}

						if(this.evento.Evento.EventoFlyer){
							;(async() => {
								const img = await getMeta(response.data.SDTEvento.Evento.EventoFlyer);
								flyerWidth = img.naturalWidth
								flyerHeight = img.naturalHeight
							})();

							this.evento.Evento.EventoFlyerCol = [
								{
									id: 1,
									src: this.evento.Evento.EventoFlyer,
									thumbnail: this.evento.Evento.EventoFlyer,
									w: flyerWidth,
									h: flyerHeight,
								},
							];
						} else {
							this.evento.Evento.EventoFlyerCol = []
						}
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoEvento = false
				}
			},
			async validarPromotorCodigo(){
				try {
					let response = await axios.post('/WSEventoPromotorValidar',
						{
							EventoId: this.eventoId,
							EventoPromotorCodigo: this.$route.params.promotorCodigo
						}
					);

					if(response.data.ErrorCod === 0){
						this.EventoPromotorEmail = response.data.EventoPromotorEmail
					} else {
						if(response.data.ErrorCod === 10){
							this.$store.dispatch('showError', 'Ocurrió un error.')
							this.$router.push({ name: 'error' });
						} else {
							this.$router.push({ name: 'evento', params: { eventSlug: this.eventoSlug, eventId: this.eventoId } });
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				}
			},
			async showMap(){
				this.isShowMap = true;
				await this.showEventMap(this.evento.Escenario.EscenarioGeo);
			},
			async showEventMap(geo) {
				try {
					let lat = -34
					let lon = -56
					lat = geo.split(',')[0]
					lon = geo.split(',')[1]

					mapboxgl.accessToken = this.mapboxAccessToken;

					let map = new mapboxgl.Map({
						container: 'map',
						style: 'mapbox://styles/mapbox/outdoors-v12',
						// style: 'mapbox://styles/mapbox/light-v10',
						center: [lon, lat],
						zoom: 15,
						// maxBounds: [
						// 	[103.6, 1.1704753],
						// 	[104.1, 1.4754753],
						// ],
					});

					new mapboxgl.Marker({ color: '#9fe870', draggable: false })
						.setLngLat([lon, lat])
						.addTo(map);

					// map.addControl(new mapboxgl.NavigationControl());
				} catch (error) {
					console.log('Error al crear el mapa');
				}
			},
			flyerOpened() {
				window.scrollTo(0, 0);
				document.querySelector("header").style.visibility = "hidden";
			},
			flyerClosed() {
				document.querySelector("header").style.visibility = "visible";
			},
			triggerFlyerClick(){
				var flyer = document.getElementById('flyer');
				var link = flyer.querySelector('figure');
				link.click();
			},
			seleccionarSector(sector, isFromMap) {
				if(this.evento.Escenario.EventoRepresentacionGrafica && this.evento.Escenario.EscenarioSVG){
					this.deseleccionarSector();
				}

				let sectorObj = this.sectores.filter((s) => {
					return s.SectorCod === sector;
				});
				sectorObj = sectorObj[0];
				if (sectorObj.EventoSectorAgotado || sectorObj.Segmentos.length <= 0) {
					// Si está agotado o no tiene configurados los segmentos
					if (this.sectorActivo === sector) {
						if(this.evento.Escenario.EventoRepresentacionGrafica && this.evento.Escenario.EscenarioSVG){
							this.deseleccionarSector();
						}

						this.sectorActivo = null;
						this.limpiarCantidades();
						this.ticketsUbicaciones = []
					}
				} else {
					if (this.sectorActivo === sector) {
						if(this.evento.Escenario.EventoRepresentacionGrafica && this.evento.Escenario.EscenarioSVG){
							this.deseleccionarSector();
						}

						this.sectorActivo = null;
						this.limpiarCantidades();
						this.ticketsUbicaciones = []
					} else {
						if(this.evento.Escenario.EventoRepresentacionGrafica && this.evento.Escenario.EscenarioSVG){
							document.querySelector('.SEC-' + sector.trim()).classList.add('sector-seleccionado');
							if(isFromMap === true){
								const el = document.getElementById('SEC-' + sector.trim());
								if(el){
									el.scrollIntoView({behavior: "smooth"});
								}
							}
						}

						this.sectorActivo = sector;
						this.limpiarCantidades();
						this.ticketsUbicaciones = []
						if(this.evento.Evento.EventoSegmentoElegible === false){
							this.sectorQtyMore(sector);
						}
					}
				}
			},
			seleccionarSectorFromMap(e){
				// Detectar qué sector se clickeó
				let sectorClickeado = e.target.parentElement.id;
				let tribId = e.target.parentElement.getAttribute('data-tribunaid');

				if(tribId){
					this.seleccionarSector(sectorClickeado, true);
				}
			},
			deseleccionarSector(){
				let sectoresSeleccionados = document.querySelectorAll('.sector-seleccionado');
				for (var b = 0; b < sectoresSeleccionados.length; b++) {
					sectoresSeleccionados[b].classList.remove('sector-seleccionado');
				}
			},
			limpiarCantidades(){
				this.sectores.forEach((sec) => {
					sec.SectorCantidad = 0
					sec.Segmentos.forEach((seg) => {
						seg.SegmentoCantidad = 0
					})
				})
			},
			async goToCheckout() {
				try {
					if(this.$route.meta.isEventPreview !== true){
						if(this.sectorActivoObj){
							this.isLoadingCheckout = true

							let isCantidadValida = false
							let cantidad = 0
							let cantidadAux = this.sectorActivoObj[0].SectorCantidad

							if(this.evento.Evento.EventoSegmentoElegible === true){
								this.sectorActivoObj[0].Segmentos.forEach((seg) => {
									cantidad = cantidad + seg.SegmentoCantidad
									if(seg.SegmentoCantidad > 0){
										isCantidadValida = true;
									}
								})
							} else {
								if(cantidadAux > 0){
									isCantidadValida = true;
									cantidad = cantidadAux
								}
							}

							if(isCantidadValida){
								this.errorCheckout = null

								let filasAsientos = [];
								this.ticketsUbicaciones.forEach((t) => {
									filasAsientos.push({ Fila: t.Fila, Asiento: t.Asiento, SegmentoId: t.SegmentoId })
								})

								let Segmentos = []

								this.sectorActivoObj[0].Segmentos.forEach((s) => {
									// if(s.SegmentoCantidad > 0){
										Segmentos.push({
											SegmentoId: Number(s.SegmentoId),
											SegmentoNombre: s.SegmentoNombre,
											EventoSegmentoInfo: s.EventoSegmentoInfo,
											ListaMonto: s.ListaMonto,
											SegmentoCantidad: Number(s.SegmentoCantidad),
											Comision: s.Comision
										})
									// }
								});

								let usrId = '80ed076b-89de-1899-1899-536d79b70d2a'
								let headers = {}
								if(this.loggedIn){
									usrId = this.user.UsuarioId
									headers = {"Authorization" : `Bearer ${ this.user.AccessToken }`}
								}

								// Creo la transacción
								let response = await axios.post('/WSTransaccion', {
									TransaccionMedio: 'W', 
									UsuarioId : usrId,
									TransaccionEventoId: Number(this.eventoId), 
									TransaccionEventoTribunaId: Number(this.sectorActivoObj[0].TribunaId), 
									TransaccionEventoSectorCod: this.sectorActivoObj[0].SectorCod, 
									TransaccionCantidad: Number(cantidad), 
									SDTFilaAsientoJSON: JSON.stringify(filasAsientos),
									EventoPromotorEmail: this.EventoPromotorEmail
								}, { headers: headers });

								if(response.data.ErrorCod === 0){
									this.transaccionId = response.data.TransaccionId
									this.$store.dispatch('setFromStateSocial', `/checkout/${this.transaccionId}`);

									this.$router.push({ name: 'evento-checkout', params: { transaccionId: this.transaccionId } });
								} else {
									if(response.data.ErrorCod === 1 || response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
										await this.logout();
									} else {
										this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.');
										this.$router.push({ name: 'home' });
									}
								}

								// if (!this.loggedIn) {
								// 	let transaccionData = {
								// 		route: 'evento-checkout',
								// 		params: { eventSlug: this.eventoSlug, eventId: this.eventoId },
								// 		trn: {
								// 			TransaccionMedio: 'W', 
								// 			// UsuarioId : null,
								// 			TransaccionEventoId: Number(this.eventoId), 
								// 			TransaccionEventoTribunaId: Number(this.sectorActivoObj[0].TribunaId), 
								// 			// TransaccionEventoTribunaNombre: this.sectorActivoObj[0].TribunaNombre,
								// 			TransaccionEventoSectorCod: this.sectorActivoObj[0].SectorCod, 
								// 			// Sector: SectorCheckout,
								// 			TransaccionCantidad: Number(cantidad), 
								// 			Segmentos: Segmentos,
								// 			TicketsUbicaciones: this.ticketsUbicaciones,
								// 			FilasAsientos: filasAsientos,
								// 			Moneda: this.sectoresInfo,
								// 			EventoPromotorEmail: this.EventoPromotorEmail
								// 		}
								// 	}

								// 	// Seteo el transaccion data por si vuelve de Google o Facebook, ya que en ese caso se pierde el
								// 	// callbackAction que seteo más abajo (para login local funciona perfecto)
								// 	this.$store.dispatch("setearTransaccionData", transaccionData);

								// 	this.$store.dispatch('AuthModule/showAuthModal', {
								// 		callbackAction: {
								// 			name: 'AuthModule/crearTransaccionYRedirigirA',
								// 			payload: {
								// 				route: 'evento-checkout',
								// 				params: { eventSlug: this.eventoSlug, eventId: this.eventoId },
								// 				trn: {
								// 					TransaccionMedio: 'W', 
								// 					// UsuarioId : null,
								// 					TransaccionEventoId: Number(this.eventoId), 
								// 					TransaccionEventoTribunaId: Number(this.sectorActivoObj[0].TribunaId), 
								// 					// TransaccionEventoTribunaNombre: this.sectorActivoObj[0].TribunaNombre,
								// 					TransaccionEventoSectorCod: this.sectorActivoObj[0].SectorCod, 
								// 					// Sector: SectorCheckout,
								// 					TransaccionCantidad: Number(cantidad), 
								// 					Segmentos: Segmentos,
								// 					TicketsUbicaciones: this.ticketsUbicaciones,
								// 					FilasAsientos: filasAsientos,
								// 					Moneda: this.sectoresInfo
								// 				}
								// 			},
								// 		}
								// 	});
								// }
							} else {
								this.errorCheckout = 'Cantidad de tickets debe ser mayor a 0'
							}
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.');
					this.$router.push({ name: 'error' });
				} finally {
					this.isLoadingCheckout = false
				}
			},
			sectorQtyLess(sectorCod){
				this.errorCheckout = null
				let sectorIndex = this.sectores.findIndex(s =>  s.SectorCod === sectorCod);
				let cantidad = this.sectores[sectorIndex].SectorCantidad;

				if(cantidad > 0){
					for(let i=(this.ticketsUbicaciones.length - 1); i>= 0; i--){
						this.ticketsUbicaciones.splice(i, 1);
						break;
					}

					this.sectores[sectorIndex].SectorCantidad = this.sectores[sectorIndex].SectorCantidad - 1
				}
			},
			sectorQtyMore(sectorCod){
				this.errorCheckout = null
				let sectorIndex = this.sectores.findIndex(s =>  s.SectorCod === sectorCod);
				let cantidad = this.sectores[sectorIndex].SectorCantidad;
				
				if(cantidad < 10){
					let ticket = {
						Id: Date.now(),
						SegmentoId: 0,
						Fila: '0',
						Asiento: '0',
					}

					this.sectores[sectorIndex].SectorCantidad = this.sectores[sectorIndex].SectorCantidad + 1
					this.ticketsUbicaciones.push(ticket);
				}
			},
			segmentoQtyLess(sectorCod, segmentoId){
				this.errorCheckout = null
				let sectorIndex;
				let segmentoIndex;
				let cantidad = 0;

				sectorIndex = this.sectores.findIndex(s =>  s.SectorCod === sectorCod);
				segmentoIndex = this.sectores[sectorIndex].Segmentos.findIndex(seg => seg.SegmentoId === segmentoId)

				cantidad = this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoCantidad;
				
				if(cantidad > 0){
					for(let i=(this.ticketsUbicaciones.length - 1); i>= 0; i--){
						if(Number(this.ticketsUbicaciones[i].SegmentoId) === Number(this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoId)){
							this.ticketsUbicaciones.splice(i, 1);
							break;
						}
					}

					this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoCantidad = 
						this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoCantidad - 1

					this.sectores[sectorIndex].SectorCantidad = this.sectores[sectorIndex].SectorCantidad - 1
				}
			},
			segmentoQtyMore(sectorCod, segmentoId){
				this.errorCheckout = null
				let sectorIndex;
				let segmentoIndex;
				let cantidad = 0;

				sectorIndex = this.sectores.findIndex(s =>  s.SectorCod === sectorCod);
				segmentoIndex = this.sectores[sectorIndex].Segmentos.findIndex(seg => seg.SegmentoId === segmentoId)

				cantidad = this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoCantidad;
				
				if(cantidad < 10){
					let ticket = {
						Id: Date.now(),
						SegmentoId: this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoId,
						Fila: '0',
						Asiento: '0',
					}

					this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoCantidad = this.sectores[sectorIndex].Segmentos[segmentoIndex].SegmentoCantidad + 1
					this.ticketsUbicaciones.push(ticket);
					this.sectores[sectorIndex].SectorCantidad = this.sectores[sectorIndex].SectorCantidad + 1
				}
			},
			async cancelarTransaccionEnCurso(){
				try {
					let response = await axios.post('/WSTransaccionCancelar2', {
						TransaccionId: this.trnEnCurso.TransaccionId
					});
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				} finally {
					this.trnEnCurso = null
				}
			},
			async transaccionEnCurso(){
				try {
					let response = await axios.post('/WSTransaccionEnCurso',
						{
							UsuarioId : this.user.UsuarioId,
							EventoId: this.eventoId
						},
						{ headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} }
					);

					if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
						// Logout
						await this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							// No tiene transacciones en curso
							this.isAlertaTransaccionConfirmed = true
						} else {
							// Tiene una transacción en curso
							this.trnEnCurso = response.data.SDTTransaccionEnCurso
							this.$modal.show('transaccion-en-curso')
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
					this.$router.push({ name: 'error' });
				}
			},
			async retomarCompra(){
				this.$router.push({ name: 'evento-checkout', params: { transaccionId: this.trnEnCurso.TransaccionId } });
			},
			async esconderTransaccionEnCurso(){
				this.$modal.hide('transaccion-en-curso')

				// Cancelar transaccion
				await this.cancelarTransaccionEnCurso();

				this.isAlertaTransaccionConfirmed = true

				// Vuelvo a dibujar los sectores
				this.$store.dispatch('cargando', true);
				await this.getEventoSectores();
				this.$store.dispatch('cargando', false);
			},
			async getEventoSectores(){
				try {
					let response = await axios.post('/WSEventoSectores', {
						EventoId: this.eventoId,
						IsDesdeRedpagos: false
					});

					if(response.data.ErrorCod === 0){
						this.sectoresInfo = {
							MonedaId: Number(response.data.SDTEventoSectores.MonedaId),
							MonedaSimbolo: response.data.SDTEventoSectores.MonedaSimbolo
						}

						let sectoresArray = response.data.SDTEventoSectores.Sectores
						sectoresArray.forEach((s) => {
							let precios = []

							s.SectorCantidad = 0

							s.Segmentos.forEach((seg) => {
								seg.SegmentoCantidad = 0,
								seg.ListaMontoInt = seg.ListaMonto.replace('.00', '')
								precios.push(Number(seg.ListaMonto))
							})

							s.SectorPrecioDesde = Math.min.apply(Math, precios)
						})

						this.sectores = sectoresArray
					} else {
						if(response.data.ErrorCod === 30){
							this.$store.dispatch('showError', response.data.ErrorDsc);
							this.$router.push({ name: 'error' });
						} else {
							console.log('Ocurrió un error al obtener los sectores')
							this.$router.push({ name: 'error' });
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al obtener los sectores.')
					this.$router.push({ name: 'error' });
				}
			}
		}
	};
</script>

<style lang="scss">
	.mapboxgl-control-container{
		visibility: hidden;
	}

	.pswp{
		width: 100vw !important;
		height: 100vh !important;
		z-index: 999 !important;
	}

	.flyer {
		& > div {
			max-width: 100%;
			max-height: calc(100% - 40px);
			@include flex(column, flex-end, center);

			@media screen and (max-width: 1050px){
				max-height: calc(100% - 34px);
			}

			.my-gallery {
				max-width: 100%;
				@include flex(column, flex-end, center);

				.gallery-thumbnail {
					max-width: 100%;
					@include flex(column, flex-end, center);
					margin: 0px;

					a {
						@include flex(column, flex-end, center);
						cursor: url("data:image/svg+xml,%3Csvg height='6' width='6' viewBox='0 0 8 8' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='4' cy='4' fill='%23eee' r='4'/%3E%3C/svg%3E") 3 3, auto;

						img {
							object-fit: cover;
							border-radius: 12px 12px 0px 0px;
							width: 100%;
							height: 100%;
							max-width: 400px;
							max-height: 350px;
						}
					}
				}
			}
		}
	}
</style>

<style lang="scss" scoped>
	@import url(https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.css);
	
	.evento {
		width: 100%;
		@include flex(column, flex-start, center);

		.evento-header {
			width: 100%;
			position: relative;
			z-index: 8;
			min-height: 560px;
			overflow: hidden;
			background-color: var(--color-secondary);
			@include flex(column, flex-end, flex-start);

			.evento-header-background {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				width: 100%;
				height: 100%;
				background-repeat: no-repeat;
				background-size: 70% auto;
				background-position: center right;
				z-index: -1;

				&.blurry {
					-webkit-filter: blur(10px);
					-moz-filter: blur(10px);
					-o-filter: blur(10px);
					-ms-filter: blur(10px);
					filter: blur(10px);
				}
			}

			&:before {
				content: " ";
				background: var(--color-secondary);
				background: radial-gradient(
					circle,
					rgba(25, 24, 36, 0) 0%,
					var(--color-secondary) 80%
				);
				position: absolute;
				bottom: 0px;
				width: 85%;
				height: 100%;
				top: 0%;
				left: 28%;
				z-index: 0;
			}

			.container, .container-fluid {
				@include flex(row, space-between, flex-end);
			}

			.evento-header-content-left {
				width: calc(100% - 400px);
				padding-bottom: 40px;
				padding-right: 40px;
				@include flex(column, flex-end, flex-start);

				.breadcrumb {
					margin-bottom: 10px;
					@include flex(row, flex-start, center);

					.breadcrumb-item {
						font-size: 11px;
						font-weight: var(--fw-300);
						letter-spacing: 0.5px;
						font-family: var(--font-sora);
						color: var(--color-white);
						text-transform: capitalize;
						padding: 5px;
					}
				}

				h1 {
					color: var(--color-white);
					font-size: 32px;
					margin: 0px;
					font-family: var(--font-sora);
					font-weight: var(--fw-700);
					max-width: 600px;
					line-height: 1.4em;
				}

				button {
					margin-top: 12px;
					margin-bottom: 30px;
					text-decoration: none;
					padding: 12px 14px;
					font-family: var(--font-sora);
					text-align: center;
					font-size: 12px;
					text-transform: uppercase;
					color: var(--color-white);
					background-color: rgba(255, 255, 255, 0.08);
					font-weight: var(--fw-600);
					line-height: 1em;
					letter-spacing: 0.7px;
					border-radius: 6px;
					border: 1px solid rgba(255, 255, 255, 0.25);
					@include transition(all .2s);
					cursor: pointer;

					i {
						font-size: 16px;
						margin-right: 4px;
					}
				}

				.divider {
					width: calc(100% + 440px);
					height: 1px;
					background-color: rgba(255, 255, 255, 0.16);
				}

				.evento-header-footer{
					margin: 20px 0px 0px 0px;
					@include flex(row, flex-start, center);

					.evento-involucrados {
						margin: 0px;
						z-index: 10;
						@include flex(row, flex-start, center);

						.involucrado {
							position: relative;
							@include transition(all 0.3s ease);
							background-color: var(--color-white);
							border-radius: 99%;
							width: 38px;
							height: 38px;
							@include flex(row, center, center);
							padding: 5px;

							&:nth-child(1) {
								margin-left: 0;
								z-index: 10;
							}

							&:nth-child(2),
							&:nth-child(3),
							&:nth-child(4) {
								margin-left: -18px;
							}

							&:nth-child(2) {
								z-index: 6;
							}

							&:nth-child(3) {
								z-index: 5;
							}

							&:nth-child(4) {
								z-index: 4;
							}

							img {
								height: 100%;
								width: 100%;
								object-fit: cover;
							}

							&:after {
								content: attr(data-tooltip);
								background: var(--color-white);
								border-radius: 8px;
								box-shadow: 5px 8px 20px rgba(0, 0, 0, 0.27);
								font-size: 11px;
								font-weight: 400;
								left: 0px;
								opacity: 0;
								padding: 3px 11px;
								position: absolute;
								text-align: center;
								top: -28px;
								@include transition(all 0.3s ease);
								visibility: hidden;
								width: -webkit-max-content;
								width: max-content;
								z-index: 10;
							}

							&:hover {
								-webkit-transform: scale(1.1);
								transform: scale(1.1);
								z-index: 10;

								&:after {
									opacity: 1;
									visibility: visible;
								}
							}
						}

						&:hover {
							.involucrado {
								margin-left: 0px !important;
							}
						}
					}

					.evento-competencia{
						margin-left: 30px;
						padding-left: 30px;
						border-left: 1px solid rgba(255, 255, 255, 0.16);
						@include flex(row, flex-start, center);

						.evento-competencia-logo{
							margin-right: 20px;
							@include flex(row, flex-start, center);

							img{
								height: 44px;
								// width: 50px;
								object-fit: contain;
							}
						}

						.evento-competencia-main{
							@include flex(column, center, flex-start);

							.evento-competencia-nombre{
								font-weight: var(--fw-700);
								text-transform: uppercase;
								color: var(--color-white);
								line-height: 1em;
								font-size: 12px;
							}

							.evento-competencia-instancia{
								font-weight: var(--fw-400);
								// text-transform: uppercase;
								color: var(--color-white);
								line-height: 1em;
								font-size: 12px;
								margin-top: 6px;
							}
						}
					}
				}
			}

			.evento-header-content-right {
				width: 400px;
				padding-bottom: 27px;
				@include flex(column, flex-end, flex-end);

				.flyer {
					max-width: 100%;
					max-height: 390px;
					overflow: hidden;
					@include flex(column, flex-end, center);
					border-radius: 12px;
					box-shadow: 0px 8px 28px rgba(0, 0, 0, 0.28);

					.ver-flyer {
						width: 100%;
						@include flex(row, center, center);
						background-color: rgba(255, 255, 255, 0.08);
						color: var(--color-white);
						font-family: var(--font-inter);
						font-weight: 300;
						text-transform: uppercase;
						letter-spacing: 2px;
						font-size: 11px;
						padding: 0px;
						height: 40px;
						border-radius: 0px 0px 12px 12px;
						cursor: url("data:image/svg+xml,%3Csvg height='6' width='6' viewBox='0 0 8 8' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='4' cy='4' fill='%23eee' r='4'/%3E%3C/svg%3E") 3 3, auto;
					}
				}
			}
		}

		.evento-main {
			width: 100%;
			padding: 60px 0px;
			background-color: var(--color-white);
			min-height: 800px;
			@include flex(row, space-between, flex-start);

			.container, .container-fluid {
				@include flex(row, space-between, flex-start);

				.evento-main-content {
					width: calc(100% - 400px);
					@include flex(column, flex-start, flex-start);
					padding-right: 40px;

					.evento-main-content-top {
						position: relative;
						width: 100%;
						margin-bottom: 30px;
						@include flex(row, flex-start, stretch);
						flex-wrap: wrap;
						gap: 20px;

						.evento-main-content-top-card{
							padding: 8px 20px;
							border: 1px solid #e8e9eb;
							transform: translate(-0.25rem, -0.25rem);
							box-shadow: 0.25rem 0.25rem 0 #e8e9eb;
							border-radius: 8px;
							@include flex(column, center, flex-start);

							.label{
								font-size: 10px;
								font-weight: var(--fw-400);
								text-transform: uppercase;
								margin-bottom: 5px;
								letter-spacing: 0.5px;
							}

							.evento-fecha{
								width: 100%;
								@include flex(row, space-between, center);

								.evento-fecha-left {
									@include flex(column, center, center);

									.fecha-dia {
										font-size: 20px;
										font-weight: var(--fw-700);
										line-height: 1.1em;
										font-family: var(--font-sora);
									}

									.fecha-mes {
										margin-top: 2px;
										font-size: 11px;
										font-weight: var(--fw-500);
										line-height: 1em;
										letter-spacing: 0px;
										text-transform: uppercase;
										font-family: var(--font-sora);
									}

									.fecha-dia-escrito {
										margin-bottom: 2px;
										font-size: 11px;
										font-weight: var(--fw-500);
										line-height: 1em;
										letter-spacing: 0px;
										text-transform: uppercase;
										font-family: var(--font-sora);
									}
								}

								.evento-fecha-divider {
									height: 1px;
									width: 16px;
									margin: 0px 10px;
									background-color: var(--color-darker);
								}

								.evento-fecha-right {
									@include flex(row, center, center);

									.fecha-hora {
										font-size: 14px;
										line-height: 1.2em;
										font-weight: var(--fw-600);
										font-family: var(--font-sora);
									}
								}
							}

							.evento-organizador{
								width: 100%;
								@include flex(row, space-between, center);

								.evento-organizador-left{
									@include flex(column, center, flex-start);

									.organizador-nombre{
										font-size: 14px;
										line-height: 1.2em;
										font-weight: var(--fw-600);
										font-family: var(--font-sora);
									}
								}

								.evento-organizador-right{
									@include flex(row, flex-end, center);
									margin-left: 20px;

									.organizador-logo {
										background-color: var(--color-white);
										border-radius: 99%;
										width: 38px;
										height: 38px;
										@include flex(row, center, center);
										padding: 4px;

										img {
											height: 100%;
											width: 100%;
											object-fit: cover;
										}
									}
								}
							}

							.evento-escenario{
								width: 100%;
								@include flex(row, space-between, center);

								.evento-escenario-left{
									@include flex(column, center, flex-start);

									.escenario-nombre{
										font-size: 14px;
										line-height: 1.2em;
										font-weight: var(--fw-600);
										font-family: var(--font-sora);
									}
								}

								.evento-escenario-right{
									@include flex(row, flex-end, center);
									margin-left: 24px;

									a{
										color: var(--color-darker);
										text-decoration: none;
									}
								}
							}
						}
					}

					.descripcion-title {
						font-family: var(--font-sora);
						font-weight: var(--fw-600);
						margin-bottom: 5px;
						font-size: 16px;
					}

					.venue-map{
						width: 100%;
						margin: 20px 0px;
						padding: 32px;
						@include transition(all .2s);
					}

					p {
						font-size: 14px;
						font-weight: var(--fw-400);
						text-align: justify;
						line-height: 1.5em;
						color: var(--color-darker);
						margin-bottom: 25px;
					}

					h3 {
						font-family: var(--font-sora);
						margin: 0;
						margin-bottom: 10px;
					}

					.sectores {
						width: 100%;
						margin-bottom: 25px;
						@include flex(column, flex-start, flex-start);

						.sector-wrapper {
							width: 100%;
							@include flex(column, flex-start, flex-end);
							margin: 5px 0px;
							-webkit-user-select: none;
							-ms-user-select: none;
							user-select: none;

							&:last-child {
								margin-bottom: 0px;
							}

							.sector {
								width: 100%;
								border: 1px solid rgba(0, 0, 0, 0.15);
								@include flex(row, space-between, center);
								padding: 0px 20px;
								border-radius: 8px;
								overflow: hidden;
								height: 76px;
								position: relative;
								cursor: pointer;
								z-index: 2;
								@include transition(all 140ms ease-in);

								&:hover {
									border: 1px solid var(--color-darker);
								}

								&:after {
									width: 26px;
									height: 26px;
									content: "";
									border: 2px solid rgba(0, 0, 0, 0.15);
									background-color: #fff;
									background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
									background-repeat: no-repeat;
									background-position: 2px 3px;
									border-radius: 50%;
									background-size: 23px;
									z-index: 2;
									position: absolute;
									right: 20px;
									top: 50%;
									transform: translateY(-50%);
									cursor: pointer;
									@include transition(all 140ms ease-in);
								}

								&.active {
									// border: 2px solid var(--color-darker);
									padding: 0px 20px;

									border: 1px solid #222222;
									transform: translate(-0.25rem, -0.25rem);
									box-shadow: 0.25rem 0.25rem 0 #222222;

									.sector-left {
										.tribuna-nombre{
											color: var(--color-darker);
										}

										.sector-nombre {
											color: var(--color-darker);
										}

										.sector-descripcion {
											color: var(--color-darker);
											font-weight: var(--fw-500);
										}
									}

									&:after {
										background-color: var(--color-darker);
										border-color: var(--color-darker);
									}
								}

								&.deselected {
									opacity: 0.25;
								}

								&.no-configurado{
									position: relative;
									cursor: not-allowed;
									border: 1px solid rgba(0, 0, 0, 0.08);

									.sector-left, .sector-right{
										-webkit-filter: blur(3px);
										-moz-filter: blur(3px);
										-o-filter: blur(3px);
										-ms-filter: blur(3px);
										filter: blur(3px);
									}

									&:after{
										-webkit-filter: blur(3px);
										-moz-filter: blur(3px);
										-o-filter: blur(3px);
										-ms-filter: blur(3px);
										filter: blur(3px);
									}

									.no-configurado-aviso{
										@include flex(row, center, center);
										position: absolute;
										top: 50%;
										left: 50%;
										width: 100%;
										height: 100%;
										transform: translate(-50%, -50%);

										&:before{
											content: '';
											position: absolute;
											top: 0;
											left: 0;
											width: 100%;
											height: 100%;
											background-color: var(--color-white);
											opacity: 0.4;
											z-index: 90;
										}
										
										span{
											font-weight: var(--fw-600);
											font-size: 13px;
											line-height: 1em;
											z-index: 91;
										}

										i{
											margin-right: 8px;
										}
									}
								}

								&.agotado {
									background-color: rgba(0, 0, 0, 0.1);
									border: none;
									cursor: not-allowed;

									&:after {
										content: none;
									}

									.sector-left {
										.tribuna-nombre{
											text-decoration: line-through;
										}

										.sector-nombre {
											text-decoration: line-through;
										}

										.sector-descripcion {
											text-decoration: line-through;
										}
									}

									.sector-right {
										.sector-agotado {
											font-weight: var(--fw-500);
											font-size: 12px;
											padding: 3px 6px;
											border-radius: 4px;
											background-color: rgba(0, 0, 0, 0.12);
										}
									}
								}

								.sector-left {
									@include flex(column, center, flex-start);

									.tribuna-nombre{
										font-size: 10px;
										font-weight: var(--fw-400);
										text-transform: uppercase;
										margin-bottom: 2px;
										letter-spacing: 0.5px;
									}

									.sector-nombre {
										font-size: 14px;
										font-weight: var(--fw-700);
										font-family: var(--font-sora);
									}

									.sector-descripcion {
										margin-top: 3px;
										font-size: 12px;
										font-weight: var(--fw-400);
										font-family: var(--font-sora);
										color: var(--color-dark);
									}
								}

								.sector-right {
									margin-right: 40px;
									@include flex(row, flex-end, center);

									.sector-desde {
										font-size: 12px;
										font-weight: var(--fw-400);
										font-family: var(--font-sora);
										color: var(--color-dark);
										line-height: 1em;
									}

									.sector-precio {
										font-size: 15px;
										font-weight: var(--fw-600);
										line-height: 1em;
										font-family: var(--font-sora);
										margin-left: 14px;
									}


									.sector-cantidad {
										z-index: 999;
										@include flex(row, center, center);

										.sector-cantidad-less {
											padding: 0px 10px;
											border-radius: 4px 0px 0px 4px;
											border-top: 1px solid rgba(0, 0, 0, 0.15);
											border-bottom: 1px solid rgba(0, 0, 0, 0.15);
											border-left: 1px solid rgba(0, 0, 0, 0.15);
											height: 38px;
											@include flex(row, center, center);
											cursor: pointer;
											@include transition(all .2s);

											i {
												font-size: 18px;
											}

											&:hover{
												background-color: rgba(0, 0, 0, 0.03);
											}
										}

										.sector-cantidad-more {
											padding: 0px 10px;
											border-radius: 0px 4px 4px 0px;
											border-top: 1px solid rgba(0, 0, 0, 0.15);
											border-bottom: 1px solid rgba(0, 0, 0, 0.15);
											border-right: 1px solid rgba(0, 0, 0, 0.15);
											height: 38px;
											@include flex(row, center, center);
											cursor: pointer;
											@include transition(all .2s);

											i {
												font-size: 18px;
											}

											&:hover{
												background-color: rgba(0, 0, 0, 0.03);
											}
										}

										.sector-cantidad-qty {
											line-height: 1em;
											@include flex(row, center, center);
											height: 38px;
											width: 20px;
											border-top: 1px solid rgba(0, 0, 0, 0.15);
											border-bottom: 1px solid rgba(0, 0, 0, 0.15);
											font-size: 14px;
											font-weight: var(--fw-600);
										}
									}
								}
							}

							.segmentos {
								width: 100%;
								@include flex(column, flex-start, flex-start);

								.segmento {
									width: 100%;
									height: 58px;
									@include flex(row, space-between, center);
									border-bottom: 1px dashed rgba(0, 0, 0, 0.15);
									padding: 0px 20px;

									&:last-child {
										border-bottom: none;
									}

									.segmento-left {
										@include flex(column, center, flex-start);

										.segmento-nombre {
											font-size: 12px;
											font-weight: var(--fw-600);
											line-height: 1em;
										}

										.segmento-descripcion {
											font-size: 12px;
											font-weight: var(--fw-400);
											line-height: 1em;
											margin-top: 5px;
										}
									}

									.segmento-right {
										@include flex(row, flex-end, center);

										.segmento-precio {
											font-size: 15px;
											font-weight: var(--fw-600);
											line-height: 1em;
											font-family: var(--font-sora);
											width: 50px;
											margin-left: 10px;
											text-align: right;
										}
									}
								}
							}

							.segmento-cantidad {
								@include flex(row, center, center);

								.segmento-cantidad-less {
									padding: 0px 10px;
									border-radius: 4px 0px 0px 4px;
									border-top: 1px solid rgba(0, 0, 0, 0.15);
									border-bottom: 1px solid rgba(0, 0, 0, 0.15);
									border-left: 1px solid rgba(0, 0, 0, 0.15);
									height: 38px;
									@include flex(row, center, center);
									cursor: pointer;
									@include transition(all .2s);

									i {
										font-size: 18px;
									}

									&:hover{
										background-color: rgba(0, 0, 0, 0.03);
									}
								}

								.segmento-cantidad-more {
									padding: 0px 10px;
									border-radius: 0px 4px 4px 0px;
									border-top: 1px solid rgba(0, 0, 0, 0.15);
									border-bottom: 1px solid rgba(0, 0, 0, 0.15);
									border-right: 1px solid rgba(0, 0, 0, 0.15);
									height: 38px;
									@include flex(row, center, center);
									cursor: pointer;
									@include transition(all .2s);

									i {
										font-size: 18px;
									}

									&:hover{
										background-color: rgba(0, 0, 0, 0.03);
									}
								}

								.segmento-cantidad-qty {
									line-height: 1em;
									@include flex(row, center, center);
									height: 38px;
									width: 20px;
									border-top: 1px solid rgba(0, 0, 0, 0.15);
									border-bottom: 1px solid rgba(0, 0, 0, 0.15);
									font-size: 14px;
									font-weight: var(--fw-600);
								}
							}

							.error-checkout{
								font-size: 12px;
								color: var(--color-red-error);
								margin-top: 4px;
							}

							button {
								width: auto;
								background-color: #222222;
								border: 1px solid #222222;
								border-radius: 8px;
								outline: none;
								padding: 14px 22px;
								color: var(--color-white);
								font-size: 12px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.4em;
								letter-spacing: 1px;
								margin: 8px 0px;
								@include transition(all 0.2s);
								cursor: pointer;

								&:hover {
									// background-color: var(--color-black);
									background-color: var(--color-primary);
									border: 1px solid #222222;
									color: #222222;
									transform: translate(-0.25rem, -0.25rem);
									box-shadow: 0.25rem 0.25rem 0 #222222;
								}

								&:disabled {
									opacity: 0.1;
									cursor: not-allowed;
								}
							}
						}
					}
				}

				aside {
					position: relative;
					width: 400px;
					@include flex(column, flex-start, flex-start);

					.map-wrapper {
						position: relative;
						@include flex(row, center, center);
						width: 100%;
						overflow: hidden;
						border-radius: 15px;
						margin: 0px;
						box-shadow: rgba(0, 0, 0, 0.1) 0px 6px 20px;

						#map {
							width: 100%;
							height: 100%;
							min-height: 300px;
						}
					}

					.map-wrapper-show {
						position: relative;
						@include flex(row, center, center);
						width: 100%;
						overflow: hidden;
						border-radius: 15px;
						margin: 0px;
						min-height: 300px;
						box-shadow: rgba(0, 0, 0, 0.1) 0px 6px 20px;
						background: url('../assets/blurred-map.jpg');
						background-repeat: no-repeat;
						background-position: center;
						background-size: cover;

						.show-map {
							color: var(--color-darker);
							font-weight: var(--fw-600);
							font-size: 12px;
							background-color: var(--color-white);
							border-radius: 4px;
							padding: 5px 8px;
							@include flex(row, center, center);
							cursor: pointer;
							@include transition(all .2s);

							&:hover{
								opacity: .9;
							}
							
							i{
								font-size: 14px;
								margin-right: 5px;
							}
						}
					}

					.evento-caracteristicas {
						width: 100%;
						padding: 20px;
						@include flex(column, flex-start, flex-start);

						.caracteristica {
							@include flex(row, flex-start, flex-start);
							margin-bottom: 25px;

							&:last-child {
								margin-bottom: 10px;
							}

							i {
								margin-top: 5px;
								margin-right: 16px;
								font-size: 24px;
							}

							.caracteristica-right {
								@include flex(column, center, flex-start);

								.caracteristica-title {
									font-family: var(--font-sora);
									font-size: 15px;
									margin-bottom: 5px;
									line-height: 1em;
								}

								.caracteristica-subtitle {
									font-size: 13px;
									font-weight: var(--fw-300);
								}
							}
						}
					}
				}
			}
		}

		.evento-loader{
			padding: 80px 0px;
			@include flex(row, center, center);
			width: 100%;
		}
	}

	@media screen and (max-width: 1400px){
		.evento{
			.evento-header {
				.container, .container-fluid {
					padding-left: 24px;
					padding-right: 24px;
				}
			}

			.evento-main{
				.container, .container-fluid{
					padding-left: 24px;
					padding-right: 24px;
				}
			}
		}
	}

	@media screen and (max-width: 1300px){
		.evento{
			.evento-header{
				.evento-header-background{
					background-size: cover;
					
					&.blurry{
						transform: scale(1.05);
					}
				}

				&:before {
					content: "";
					background: var(--color-darker);
					opacity: 0.6;
					width: 100%;
					left: 0%;
				}
			}

			.evento-main{
				padding: 30px 0px;
			}
		}
	}

	@media screen and (max-width: 1120px){
		.evento{
			.evento-main{
				.container{
					max-width: 880px;
					@include flex(column, flex-start, flex-start);

					.evento-main-content{
						width: 100%;
						padding-right: 0px;
					}

					aside{
						margin-top: 20px;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1050px){
		.evento{
			.evento-header{
				min-height: unset;
				padding: 128px 0px 40px 0px;

				.evento-header-content-left{
					width: calc(100% - 240px);
					padding-bottom: 0px;
					padding-right: 20px;

					.breadcrumb{
						margin-bottom: 5px;
					}

					h1{
						font-size: 26px;
					}

					.divider{
						width: 100%;
					}

					button{
						margin-top: 10px;
						margin-bottom: 15px;
						padding: 10px 12px;
						font-size: 11px;
					}

					.evento-header-footer{
						margin: 15px 0px 0px 0px;

						.evento-involucrados{
							.involucrado{
								width: 34px;
								height: 34px;
							}
						}

						.evento-competencia{
							margin-left: 15px;
							padding-left: 15px;

							.evento-competencia-logo{
								margin-right: 15px;

								img{
									width: 38px;
									height: 38px;
									object-fit: contain;
								}
							}

							.evento-competencia-main{
								.evento-competencia-nombre{
									font-size: 11px;
									font-weight: var(--fw-600);
								}

								.evento-competencia-instancia{
									font-size: 11px;
									font-weight: var(--fw-300);
								}
							}
						}
					}
				}

				.evento-header-content-right{
					width: 240px;
					padding-bottom: 0px;

					.flyer{
						.ver-flyer{
							height: 34px;
							font-size: 10px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 740px){
		.evento{
			.evento-header{
				.container{
					@include flex(column, flex-start, center);
					max-width: 500px;
				}

				.evento-header-content-left{
					width: 100%;
					margin-bottom: 40px;

					h1{
						font-size: 22px;
					}

					.divider{
						width: 100%;
					}

					button{
						margin-top: 10px;
						margin-bottom: 15px;
						padding: 9px 12px;
						font-size: 10px;
					}
				}

				.evento-header-content-right{
					width: 100%;
					@include flex(column, center, center);

					&.skeleton{
						display: none;
					}
				}
			}

			.evento-main{
				.container{
					.evento-main-content{
						.evento-main-content-top{
							margin-bottom: 20px;
						}

						.descripcion-title{
							font-size: 15px;
						}

						p{
							line-height: 1.6em;
							font-size: 13px;
						}

						.sectores{
							.sector-wrapper{
								.sector{
									height: 70px;
									padding: 0 16px;

									.sector-left{
										.sector-nombre{
											font-size: 13px;
										}

										.sector-descripcion{
											font-size: 11px;
										}
									}

									.sector-right{
										.sector-desde{
											font-size: 11px;
										}
									}
								}
							}
						}
					}

					aside{
						margin-top: 20px;
						width: 100%;

						.evento-caracteristicas{
							padding: 20px 14px;

							.caracteristica{
								margin-bottom: 20px;

								i{
									font-size: 22px;
								}

								.caracteristica-right{
									.caracteristica-title{
										font-size: 14px;
									}

									.caracteristica-subtitle{
										font-size: 12px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 740px){
		.evento{
			.evento-header{
				.container{
					@include flex(column, flex-start, center);
					max-width: 500px;
				}

				.evento-header-content-left{
					width: 100%;
					margin-bottom: 40px;

					h1{
						font-size: 22px;
					}

					.divider{
						width: 100%;
					}

					button{
						margin-top: 10px;
						margin-bottom: 15px;
						padding: 9px 12px;
						font-size: 10px;
					}
				}

				.evento-header-content-right{
					width: 100%;
					@include flex(column, center, center);
				}
			}

			.evento-main{
				.container{
					.evento-main-content{
						.sectores{
							.sector-wrapper{
								.sector{
									height: auto;
									padding: 12px 16px;

									.sector-left{
										.sector-nombre{
											font-size: 13px;
										}

										.sector-descripcion{
											font-size: 11px;
										}
									}

									.sector-right{
										.sector-desde{
											font-size: 11px;
										}
									}

									&.active{
										padding: 12px 16px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 540px){
		.evento{
			.evento-main{
				.container{
					.evento-main-content{
						.sectores{
							.sector-wrapper{
								.segmentos{
									.segmento{
										height: unset;
										padding: 8px 14px;

										.segmento-left{
											.segmento-descripcion{
												font-size: 11px;
												line-height: 1.4em;
												margin-top: 4px;
											}
										}

										.segmento-right{
											.segmento-cantidad{
												.segmento-cantidad-less{
													height: 34px;
													padding: 0 7px;

													i{
														font-size: 15px;
													}
												}

												.segmento-cantidad-qty{
													font-size: 13px;
													height: 34px;
													width: 17px;
												}

												.segmento-cantidad-more{
													height: 34px;
													padding: 0 7px;

													i{
														font-size: 15px;
													}
												}
											}

											.segmento-precio{
												width: 46px;
												font-size: 13px;
											}
										}
									}
								}

								.sector{
									.sector-right{
										.sector-cantidad{
											.sector-cantidad-less{
												height: 34px;
												padding: 0 7px;

												i{
													font-size: 15px;
												}
											}

											.sector-cantidad-qty{
												font-size: 13px;
												height: 34px;
												width: 17px;
											}

											.sector-cantidad-more{
												height: 34px;
												padding: 0 7px;

												i{
													font-size: 15px;
												}
											}
										}

										.segmento-cantidad{
											.segmento-cantidad-less{
												height: 34px;
												padding: 0 7px;

												i{
													font-size: 15px;
												}
											}

											.segmento-cantidad-qty{
												font-size: 13px;
												height: 34px;
												width: 17px;
											}

											.segmento-cantidad-more{
												height: 34px;
												padding: 0 7px;

												i{
													font-size: 15px;
												}
											}
										}

										.sector-precio{
											width: auto;
											font-size: 13px;
											margin-left: 10px;
										}
									}
								}

								button{
									padding: 11px 18px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 500px){
		.evento{
			.evento-main{
				.container{
					.evento-main-content{
						.evento-main-content-top{
							gap: 16px;

							.evento-main-content-top-card{
								width: 100%;

								.evento-fecha{
									@include flex(row, flex-start, center);

									.evento-fecha-left{
										.fecha-dia-escrito, .fecha-mes{
											font-size: 10px;
										}

										.fecha-dia{
											font-size: 17px;
										}
									}

									.evento-fecha-divider{
										width: 14px;
									}

									.evento-fecha-right{
										.fecha-hora{
											font-size: 13px;
										}
									}
								}

								.evento-organizador{
									.evento-organizador-left{
										.organizador-nombre{
											font-size: 13px;
										}
									}

									.evento-organizador-right{
										.organizador-logo{
											width: 34px;
											height: 34px;
										}
									}
								}

								.evento-escenario{
									.evento-escenario-left{
										.escenario-nombre{
											font-size: 13px;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 400px){
		.evento{
			.evento-main{
				.container{
					.evento-main-content{
						.sectores{
							.sector-wrapper{
								.sector{
									.sector-right{
										.sector-desde{
											display: none;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>
